import {useProfile} from "@brg/auth";
import {FC, useCallback, useMemo, useState} from "react";
import {API, Endpoints, Lang, Team, TeamAPI} from "@brg/api";
import styled from "styled-components";
import {BREAKPOINTS, Colors, FlexBox, HintTooltip, Skeleton, useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import {createEmptyLangObject} from "../../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {CreateLinkTo, LinkTo} from "../../../../constants/linkTo";
import {useHistory} from "react-router-dom";
import {useGetPersonalChannel} from "../../../../hooks/api/useGetPersonalChannel";
import { MAX_CHANNEL_COUNT_TO_USER, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { DRAFT_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { tooptipStylesWhite } from "shared/constants/tooptipStyles";
import PlusSvg from "shared/assets/32/PlusSvg";

export const Outer = styled(FlexBox)`
    gap: 16px;
    max-width: 270px;
    align-items: center;

    @media(max-width: ${BREAKPOINTS.MOBILE_MAX}px) {
        width: 100%;
        max-width: none;
        justify-content:space-between;
    }
`;

const Button  = styled.div<{disabled?: boolean, isChannelCreated?: boolean}>`
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: ${Colors.geoWhite100};
    border: 1px solid #909090;
    color: ${({ disabled }) => disabled ? Colors.galBlack31 : Colors.galBlack100};
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    border-radius: 3px;
    width: max-content;
    padding: 16px 36px;
    white-space: nowrap;

    ::disabled {
        color: tomato;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
        height: 28px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
        width: 100%;
        font-weight: 700;
    }
`

export const CreateChannelButton: FC<{ designerId: string, isMe?: boolean }> = ({ designerId, isMe }) => {
    const profile = useProfile()
    const [isChannelLoading, setIsChannelLoading] = useState(false)
    const { t, i18n: { language} } = useTranslation()
    const history = useHistory();
    const isMobile = useBreakpoint(BREAKPOINTS.MOBILE_MAX);
    const {data: channelsInfo, isLoading} = useGetPersonalChannel(designerId || '', true);

    const authorChannels = useMemo(() => {
        if (isLoading) return null
        return channelsInfo?.personalChannels || null
    } , [channelsInfo, isLoading])

    const isMAXchannelsCount = !!authorChannels && authorChannels?.length === MAX_CHANNEL_COUNT_TO_USER

    const onUpdateChannelStatus = async (id: string) => {
        return await API.request('/api/Team/UpdateStatus')
        .endpoint(Endpoints.geograffee)
        .post()
        .body({
            "teamId": id,
            "status": DRAFT_TEAM_STATUS
        })
        .send()
        .then((r) => r)
    }

    const onClick = useCallback(() => {

        if (isLoading || isChannelLoading) return

        history.push(LinkTo.teamCreateConstructor);

        // if (authorChannels && authorChannels?.length < MAX_CHANNEL_COUNT_TO_USER) {
        //     // setIsChannelLoading(true)
        //     window.open(LinkTo.teamCreateConstructor, '_BLANK');
        //     // TeamAPI.Add({
        //     //     name: createEmptyLangObject('', ['ru', 'en']),
        //     //     initialTab: '',
        //     //     ownersIDs: [profile?.accountId || ''],
        //     //     moderationType: ModerationType.Channel,
        //     // } as Team<'Global'> & any)
        //     //     .then((res) => res.json())
        //     //     .then((teamId: any) => {
        //     //         onUpdateChannelStatus(teamId)
        //     //         setTimeout(() => {
        //     //             history.replace(CreateLinkTo.teamEdit(teamId));
        //     //             setIsChannelLoading(false)
        //     //         }, 800);
        //     //     });
        //     return;
        // }

        // history.push('/teams/' + channel?.teamId)

    }, [isLoading, isChannelLoading, authorChannels, history, profile?.accountId])

    // if (isLoading || isChannelLoading) {
    //     return (
    //         <Skeleton height={20} width={150} />
    //     )
    // }

    if (!designerId || (designerId !== profile?.accountId)) return null;

    if (authorChannels && authorChannels?.length > 0) {
        return (
            <Outer>
                <HintTooltip
                    customStyle={tooptipStylesWhite}
                    // isPermanent={true} 
                    noArrow 
                    activeOnMobile 
                    positionY="top" 
                    text={t('subscription.hints.create_channel_info_max')}
                    z={6} 
                    hidden={!isMAXchannelsCount}
                    onWhiteBg
                    {...(isMobile ? { w: '100%'} : {})}
                >
                    <Button disabled={isChannelLoading || isLoading || isMAXchannelsCount} onClick={onClick}>
                        <PlusSvg />
                        &nbsp;&nbsp;
                        {t('subscription.create_more_channel')}
                    </Button>
                </HintTooltip>
                <InfoIcon msg={t('subscription.hints.create_channel_info')} stc />
            </Outer>
        )
    }

    return (
        <Outer>
            <Button disabled={isChannelLoading || isLoading || isMAXchannelsCount} onClick={onClick}>
                <PlusSvg />
                &nbsp;&nbsp;
                {t('subscription.create_more_channel')}
            </Button>
            <InfoIcon msg={t('subscription.hints.create_channel_info')} stc />
        </Outer>
    )
}import {useProfile} from "@brg/auth";
import {FC, useCallback, useMemo, useState} from "react";
import {API, Endpoints, Lang, Team, TeamAPI} from "@brg/api";
import styled from "styled-components";
import {BREAKPOINTS, Colors, FlexBox, HintTooltip, Skeleton, useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import {createEmptyLangObject} from "../../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {CreateLinkTo, LinkTo} from "../../../../constants/linkTo";
import {useHistory} from "react-router-dom";
import {useGetPersonalChannel} from "../../../../hooks/api/useGetPersonalChannel";
import { MAX_CHANNEL_COUNT_TO_USER, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { DRAFT_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { tooptipStylesWhite } from "shared/constants/tooptipStyles";
import PlusSvg from "shared/assets/32/PlusSvg";

export const Outer = styled(FlexBox)`
    gap: 16px;
    max-width: 270px;
    align-items: center;

    @media(max-width: ${BREAKPOINTS.MOBILE_MAX}px) {
        width: 100%;
        max-width: none;
        justify-content:space-between;
    }
`;

const Button  = styled.div<{disabled?: boolean, isChannelCreated?: boolean}>`
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: ${Colors.geoWhite100};
    border: 1px solid #909090;
    color: ${({ disabled }) => disabled ? Colors.galBlack31 : Colors.galBlack100};
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    border-radius: 3px;
    width: max-content;
    padding: 16px 36px;
    white-space: nowrap;

    ::disabled {
        color: tomato;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
        height: 28px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
        width: 100%;
        font-weight: 700;
    }
`

export const CreateChannelButton: FC<{ designerId: string, isMe?: boolean }> = ({ designerId, isMe }) => {
    const profile = useProfile()
    const [isChannelLoading, setIsChannelLoading] = useState(false)
    const { t, i18n: { language} } = useTranslation()
    const history = useHistory();
    const isMobile = useBreakpoint(BREAKPOINTS.MOBILE_MAX);
    const {data: channelsInfo, isLoading} = useGetPersonalChannel(designerId || '', true);

    const authorChannels = useMemo(() => {
        if (isLoading) return null
        return channelsInfo?.personalChannels || null
    } , [channelsInfo, isLoading])

    const isMAXchannelsCount = !!authorChannels && authorChannels?.length === MAX_CHANNEL_COUNT_TO_USER

    const onUpdateChannelStatus = async (id: string) => {
        return await API.request('/api/Team/UpdateStatus')
        .endpoint(Endpoints.geograffee)
        .post()
        .body({
            "teamId": id,
            "status": DRAFT_TEAM_STATUS
        })
        .send()
        .then((r) => r)
    }

    const onClick = useCallback(() => {

        if (isLoading || isChannelLoading) return

        history.push(LinkTo.teamCreateConstructor);

        // if (authorChannels && authorChannels?.length < MAX_CHANNEL_COUNT_TO_USER) {
        //     // setIsChannelLoading(true)
        //     window.open(LinkTo.teamCreateConstructor, '_BLANK');
        //     // TeamAPI.Add({
        //     //     name: createEmptyLangObject('', ['ru', 'en']),
        //     //     initialTab: '',
        //     //     ownersIDs: [profile?.accountId || ''],
        //     //     moderationType: ModerationType.Channel,
        //     // } as Team<'Global'> & any)
        //     //     .then((res) => res.json())
        //     //     .then((teamId: any) => {
        //     //         onUpdateChannelStatus(teamId)
        //     //         setTimeout(() => {
        //     //             history.replace(CreateLinkTo.teamEdit(teamId));
        //     //             setIsChannelLoading(false)
        //     //         }, 800);
        //     //     });
        //     return;
        // }

        // history.push('/teams/' + channel?.teamId)

    }, [isLoading, isChannelLoading, authorChannels, history, profile?.accountId])

    // if (isLoading || isChannelLoading) {
    //     return (
    //         <Skeleton height={20} width={150} />
    //     )
    // }

    if (!designerId || (designerId !== profile?.accountId)) return null;

    if (authorChannels && authorChannels?.length > 0) {
        return (
            <Outer>
                <HintTooltip
                    customStyle={tooptipStylesWhite}
                    // isPermanent={true} 
                    noArrow 
                    activeOnMobile 
                    positionY="top" 
                    text={t('subscription.hints.create_channel_info_max')}
                    z={6} 
                    hidden={!isMAXchannelsCount}
                    onWhiteBg
                    {...(isMobile ? { w: '100%'} : {})}
                >
                    <Button disabled={isChannelLoading || isLoading || isMAXchannelsCount} onClick={onClick}>
                        <PlusSvg />
                        &nbsp;&nbsp;
                        {t('subscription.create_more_channel')}
                    </Button>
                </HintTooltip>
                <InfoIcon msg={t('subscription.hints.create_channel_info')} stc />
            </Outer>
        )
    }

    return (
        <Outer>
            <Button disabled={isChannelLoading || isLoading || isMAXchannelsCount} onClick={onClick}>
                <PlusSvg />
                &nbsp;&nbsp;
                {t('subscription.create_more_channel')}
            </Button>
            <InfoIcon msg={t('subscription.hints.create_channel_info')} stc />
        </Outer>
    )
}